import { TextField, styled } from '@mui/material';

export default styled(TextField)({
  '& .MuiInputBase-root': {
    fontSize: 20,
  },
});
